import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Spin, Descriptions, message, Modal, Input, Result, Icon } from 'antd';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPrint, faEye } from '@fortawesome/free-solid-svg-icons';
import {
    cashlessUnRemittedViewsAccount,
    setCashlessRemittanceStatus,
} from './ducks';
 
import PageHeader from '../../components/PageHeader';
import ReactTable from '../../components/ReactTable';
import Card from '../../components/Card';
import Container from '../../components/Container';
import Spacer from '../../components/Spacer';
 
export class ListViews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadSpin: false,
            isReject: false,
            rejectReason: "",
            bankRef: "",
            isVisible: false,
            isChanging: false,
            newStatus: false,
            remittanceStatus: "",
            showEpod: false,
            selectedEpodBankRef: null,
 
            showTrackingNumbers: false,
            selectedTrackingNumbers: []
        };
    }
 
    fetchViewAccount = () => {
        const { urViews, match } = this.props;
 
        this.setState({ loadSpin: true });
 
        return urViews(match.params.id)
            .finally(() => {
                this.setState({ loadSpin: false });
            });
    };
    componentDidMount() {
        this.fetchViewAccount();
    }
    showAlertModal(status) {
        const { rejectReason } = this.state;
        if(status == 'reject'){
            if (!rejectReason || !rejectReason.trim()) {
                message.error('Please enter a reason for rejection.');
                return;
            }
        }
        this.setState({
            isVisible: true,
            newStatus:false,
            remittanceStatus:status,
            isReject: false,
        });
    }
    setCashlessRemittanceStatus(dm) {
        const { doCashlessRemittanceStatus } = this.props;
        const { remittanceStatus, rejectReason, bankRef } = this.state;
        this.setState({
            isChanging: true,
        });
        doCashlessRemittanceStatus(dm,bankRef, remittanceStatus, {rejectReason})
        .then((action) => {
            this.setState({
                isChanging: false,
                isVisible:false,
                rejectReason:""
            });
            const code = action.payload.data.code;
            const messageText = action.payload.data.message;
            if (code === 200) {
                message.success(messageText);
                return this.fetchViewAccount();
            }
            message.error(messageText);
            return null;
        })
        .catch((error) => {
            this.setState({
                isChanging: false,
                isVisible:false,
                rejectReason:""
            });
            console.error(error);
            message.error(error.error.response.data.message);
        });
    }
    closeReject = () => {
        this.setState({
            isReject: false,
            rejectReason: "",
        });
    };
    showReject = () => {
        this.setState({
            isReject: true,
            rejectReason: "",
        });
    }
    cancelHandler =()=> {
        this.setState({
            isVisible: false,
        });
    }
    closeShowEpod = () => {
        this.setState({
            showEpod: false,
            selectedEpodBankRef: null,
        });
    };
    openShowEpod = (bankRef) => {
        const { viewAccount } = this.props;
        if (!viewAccount.document) {
            message.info('No ePOD available.');
            return;
        }
        console.log('document:', viewAccount.document);
        const document = viewAccount.document.find(
            doc => (doc.tracking_number|| 'No Bank Reference') === bankRef
        );
        if (!document) {
            message.info('No ePOD available for this bank reference.');
            return;
        }

        window.open(
            `${process.env.REACT_APP_API_URL}/${document.filename}`,
            '_blank'
        );
    };
    getSelectedEpodDocuments = () => {
        const { viewAccount } = this.props;
        const { selectedEpodBankRef } = this.state;
 
        if (!viewAccount.document || selectedEpodBankRef === null) {
            return [];
        }
 
        return viewAccount.document.filter(
            doc => (doc.bank_ref || 'No Bank Reference') === selectedEpodBankRef
        );
    };
    inArray(userId, ids) {
    var id = ids.length;
    for(var i = 0; i < id; i++) {
      if(ids[i] == userId) return true;
    }
    return false;
  }
  openTrackingNumbers = (trackingNumbers) => {
    this.setState({
        showTrackingNumbers: true,
        selectedTrackingNumbers: trackingNumbers
    });
};
 
closeTrackingNumbers = () => {
    this.setState({
        showTrackingNumbers: false,
        selectedTrackingNumbers: []
    });
};
 
getBankRefData = () => {
    const { viewAccount } = this.props;
 
    if (!viewAccount.remittance) {
        return [];
    }
 
    const grouped = {};
 
    viewAccount.remittance.forEach(item => {
        const bankRef = item.bank_name + "_" + item.bank_ref || 'No Bank Reference';
 
        if (!grouped[bankRef]) {
            grouped[bankRef] = {
                bank_ref: item.bank_ref,
                bank_name: item.bank_name,
                amount: 0,
                remittance_status: item.remittance_status,
                tracking_numbers: []
            };
        }
 
        grouped[bankRef].amount += Number(item.amount || 0);
        grouped[bankRef].tracking_numbers.push({
            tracking_number: item.tracking_number,
            amount: Number(item.amount || 0),
            remittance_status: item.remittance_status
        });
    });
 
    return Object.values(grouped);
};
    render() {
        const imageHandler = 'https://img.icons8.com/wired/2x/file-delete.png';
        const { loadSpin, isVisible, isChanging, newStatus } = this.state;
        const { viewAccount, user } = this.props;
        const selectedEpodDocuments = this.getSelectedEpodDocuments();
 
        return (
            <div className="ListView">
                <PageHeader
                    title="VIEW CASHLESS-REMITTANCE"
                />
                <Spacer />
                <Container>
                    <Card>
                        <Spin spinning={loadSpin} tip="Loading Cashless Remittance view...">
                            <Descriptions bordered size="small">
                                <Descriptions.Item label="Dispatch Number">
                                    {viewAccount.remittance
                                        ? viewAccount.remittance[0].dm
                                        : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Type">
                                    {viewAccount.remittance ? viewAccount.remittance[0].type : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Dispatch Date">
                                    {viewAccount.remittance
                                        ? viewAccount.remittance[0].dispatch_date
                                        : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Driver">
                                    {viewAccount.remittance ? viewAccount.remittance[0].driver : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Vehicle">
                                    {viewAccount.remittance
                                        ? viewAccount.remittance[0].vehicle_name
                                        : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Date Remitted">
                                    {viewAccount.remittance
                                        ? viewAccount.remittance[0].created_date
                                        : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Total Amount">
                                    {viewAccount.remittance
                                        ? `₱ ${viewAccount.total_amount
                                            .toFixed(2)
                                            .toString()
                                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                                        : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Processed By">
                                    {viewAccount.remittance
                                        ? viewAccount.remittance[0].created_by_name
                                        : ''}
                                </Descriptions.Item>
                            </Descriptions>
                            <Spacer />
                            {this.inArray(user.role_id,[5]) ?
                            (
                                viewAccount.remittance &&
                                viewAccount.remittance[0].remittance_status != 'reject' ? (
                                    <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                                        <Button
                                            type="primary"
                                            style={{ flex: 1 }}
                                            onClick={() => this.showAlertModal('verified')}
                                        >
                                            Verified
                                        </Button>
 
                                        <Button
                                            type="primary"
                                            style={{ flex: 1 }}
                                            onClick={() => this.showAlertModal('remitted')}
                                        >
                                            Remitted
                                        </Button>
 
                                        <Button
                                            type="primary"
                                            style={{ flex: 1 }}
                                            onClick={() => this.showReject()}
                                        >
                                            Reject
                                        </Button>
                                    </div>
                                ) : null
                            ): ''}
                            {/* <Button
                                type="primary"
                                block
                                style={{ marginTop: 5 }}
                                onClick={() =>
                                    window.open(
                                        `${process.env.REACT_APP_API_URL}/web/cashless-remittance/print/${viewAccount.remittance.id}`,
                                        '_blank'
                                    )
                                }
                            >
                                Print
                            </Button> */}
                        </Spin>
                    </Card>
                    <Spacer />
                    <Card
                        extra={`Total: ${viewAccount.remittance ? viewAccount.remittance.length : 0
                            }`}
                    >
                        <Spin spinning={loadSpin} tip="Loading Cashless Remittance view...">
                            <ReactTable
                                data={this.getBankRefData()}
                                columns={[
                                    {
                                        Header: 'Bank Ref',
                                        accessor: 'bank_ref',
                                    },
                                    {
                                        Header: 'Bank Name',
                                        accessor: 'bank_name',
                                    },
                                    {
                                        Header: 'Amount',
                                        accessor: 'amount',
                                        Cell: ({ value }) =>
                                            `₱${Number(value || 0)
                                                .toFixed(2)
                                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
                                    },
                                    {
                                        Header: 'Status',
                                        accessor: 'remittance_status',
                                    },
                                    {
                                        Header: 'Tracking Numbers',
                                        accessor: 'tracking_numbers',
                                        Cell: ({ value }) => (
                                            <Button
                                                type="primary"
                                                onClick={() => this.openTrackingNumbers(value)}
                                            >
                                                <Icon viewBox="0 0 1024 1024">
                                                    <FontAwesomeIcon icon={faEye} fixedWidth />
                                                </Icon>
                                                &nbsp; View ({value.length})
                                            </Button>
                                        ),
                                },
                                {
                                    Header: 'ePOD',
                                    id: 'epod',
                                    Cell: ({ original }) => (
                                        <Button
                                            type="primary"
                                            onClick={() => this.openShowEpod(original.bank_name + "_" + original.bank_ref)}
                                        >
                                            Show ePOD
                                        </Button>
                                    ),
                                },
                            ]}
                            />
                        </Spin>
                    </Card>
                </Container>
                <Modal
                    title="Tracking Numbers"
                    visible={this.state.showTrackingNumbers}
                    onCancel={this.closeTrackingNumbers}
                    footer={[
                        <Button
                            key="close"
                            onClick={this.closeTrackingNumbers}
                        >
                            Close
                        </Button>
                    ]}
                >
                    <div>
                        {/* Header */}
                        <div
                            style={{
                                display: 'flex',
                                fontWeight: 'bold',
                                borderBottom: '1px solid #ddd',
                                padding: '10px 0'
                            }}
                        >
                            <div style={{ flex: 2 }}>
                                Tracking Number
                            </div>
                            <div style={{ flex: 2 }}>
                                Status
                            </div>
                            <div style={{ flex: 1, textAlign: 'right' }}>
                                Amount
                            </div>
                        </div>
 
                        {/* Rows */}
                        {this.state.selectedTrackingNumbers.map((item, index) => (
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    borderBottom: '1px solid #eee',
                                    padding: '10px 0'
                                }}
                            >
                                <div style={{ flex: 2 }}>
                                    {item.tracking_number}
                                </div>
                                <div style={{ flex: 2 }}>
                                    {item.remittance_status}
                                </div>
                                <div
                                    style={{
                                        flex: 1,
                                        textAlign: 'right'
                                    }}
                                >
                                    ₱{Number(item.amount || 0)
                                        .toFixed(2)
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </div>
                        ))}
 
                        {/* Total */}
                        <div
                            style={{
                                display: 'flex',
                                padding: '12px 0',
                                fontWeight: 'bold'
                            }}
                        >
                            <div style={{ flex: 2 }}>
                                Total
                            </div>
 
                            <div
                                style={{
                                    flex: 1,
                                    textAlign: 'right'
                                }}
                            >
                                ₱{this.state.selectedTrackingNumbers
                                    .reduce(
                                        (total, item) =>
                                            total + Number(item.amount || 0),
                                        0
                                    )
                                    .toFixed(2)
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal
                    visible={this.state.isReject}
                    onCancel={this.closeReject}
                    footer={null}
                    title="Reject Remittance"
                >
                    <div>
                        <label
                            style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontWeight: 'bold',
                            }}
                        >
                            Reason
                        </label>
 
                        <Input.TextArea
                            rows={4}
                            placeholder="Enter reason for rejection"
                            value={this.state.rejectReason}
                            onChange={(e) =>
                                this.setState({
                                    rejectReason: e.target.value,
                                })
                            }
                        />
 
                        <div
                            style={{
                                marginTop: '20px',
                                textAlign: 'right',
                            }}
                        >
                            <Button
                                style={{ marginRight: '8px' }}
                                onClick={this.closeReject}
                            >
                                Cancel
                            </Button>
 
                            <Button
                                type="danger"
                                disabled={isChanging}
                                onClick={() =>
                                    // this.handleReject(this.state.rejectReason, viewAccount.remittance[0].dm, 'reject')
                                    this.showAlertModal('reject')
                                }
                            >
                                Confirm
                            </Button>
                        </div>
                    </div>
                </Modal>
                <Modal
                    title="Status Update"
                    closable={false}
                    visible={isVisible}
                    footer={[
                        <Button
                            key="cancel"
                            type="default"
                            onClick={this.cancelHandler}
                            disabled={isChanging}
                        >
                            Cancel
                        </Button>,
 
                        <Button
                            key="update"
                            type="primary"
                            loading={isChanging}
                            onClick={
                                newStatus === false
                                    ? () => this.setCashlessRemittanceStatus(
                                        viewAccount.remittance[0].dm
                                    )
                                    : this.cancelHandler
                            }
                        >
                            {newStatus === false ? 'Update' : 'Done'}
                        </Button>
                    ]}
                >
                    <div style={{ marginBottom: '20px' }}>
                            <label
                                style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: 'bold'
                                }}
                            >
                                Bank Reference
                            </label>
 
                            <Input
                                placeholder="Enter bank reference"
                                value={this.state.bankRef}
                                onChange={(e) =>
                                    this.setState({
                                        bankRef: e.target.value
                                    })
                                }
                            />
                        </div>
 
                    <Result
                        status={newStatus === false ? 'info' : 'success'}
                        title={
                            newStatus === false
                                ? `Are you sure you want to update the status?`
                                : 'status update'
                        }
                    />
                </Modal>
                <Modal
                    title={`Actual PoD - ${this.state.selectedEpodBankRef || ''}`}
                    visible={this.state.showEpod}
                    onCancel={this.closeShowEpod}
                    footer={null}
                >
                    {selectedEpodDocuments.length > 0 ? (
                        selectedEpodDocuments.map((doc, index) => (
                            <div key={index} style={{ marginBottom: 20 }}>
                                <img
                                    alt={"Bank Reference: " + doc.bank_ref}
                                    style={{ width: '100%' }}
                                    src={`${process.env.REACT_APP_API_URL}/${doc.filename}`}
                                />
 
                                <Button
                                    block
                                    style={{ marginTop: 10 }}
                                    onClick={() => {
                                        window.open(
                                            `${process.env.REACT_APP_API_URL}/${doc.filename}`,
                                            "_blank"
                                        );
                                    }}
                                >
                                    <Icon viewBox="0 0 1024 1024">
                                        <FontAwesomeIcon icon={faPrint} fixedWidth />
                                    </Icon>
                                    Download POD {index + 1}
                                </Button>
                            </div>
                        ))
                    ) : (
                        <img
                            alt="No POD"
                            style={{ width: '100%' }}
                            src={imageHandler}
                        />
                    )}
                </Modal>
            </div>
        );
    }
}
 
const mapStateToProps = state => ({
    viewAccount: state.cashlessRemittance.listViews,
    user: state.auth.user
});
 
const mapDispatchToProps = {
    urViews: cashlessUnRemittedViewsAccount,
    doCashlessRemittanceStatus: setCashlessRemittanceStatus,
};
 
ListViews.propTypes = {
    user: PropTypes.oneOfType([PropTypes.object]).isRequired,
    viewAccount: PropTypes.oneOfType([PropTypes.object]).isRequired,
    urViews: PropTypes.func.isRequired,
    match: PropTypes.oneOfType([PropTypes.object]).isRequired,
    doCashlessRemittanceStatus: PropTypes.func.isRequired,
};
 
export default connect(mapStateToProps, mapDispatchToProps)(ListViews);
 
 